import MapConfig from "../utils/map-config.json"; 

const HomeControl = (props) => {
  let settings = MapConfig.Map;

  const resetView = () => {
    props.map.setView(settings.center, settings.zoom);
  }

  return (
    <>
      <button className="ccl-button ccl-button--default ccl-button--default-neg map-button" onClick={() => resetView()} aria-label="Home">
        <i className="fa-solid fa-house"></i>
      </button>
    </>
  );
}

export default HomeControl;
